import React, { CSSProperties, FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image'

export interface CardProps {
  title?: string
  path?: string
  featuredImage?: any
  content?: string
  meta?: {
    time: string
    timePretty: string
    tag: string | null
  }
  image?: GatsbyImageProps
  halfImage?: boolean
  small?: boolean
  compact?: boolean
  style?: CSSProperties
  children?: ReactNode
}

const StyledCard = styled(Link)`
  display: block;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 1px 1px #e6e6e6, 0 2px 4px #e6e6e6;
  transition: 0.5s all;
  width: 100%;
  height: 100%;
  overflow: hidden;

  &:hover {
    transform: translate3d(0, -5px, 0);
    box-shadow: 0 1px 1px #ccc, 0 4px 4px #ccc;
  }
`

const StyledArticle = styled.article`
  display: inline-block;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
    grid-area: unset !important;
  }
`

const FeaturedImage = styled(GatsbyImage)<CardProps>`
  background-position: center;
  background-size: cover;
  max-width: 100%;
  border-top-left-radius: 3px;

  ${(props) =>
    props.halfImage
      ? `
    width: 50%;
    float: left;
    margin-right: 30px;
    height: 320px;
    border-bottom-left-radius: 3px;

    @media (max-width: ${props.theme.breakpoints.sm}) {
      width: 100%;
      float: none;
      height: 190px;
    }
  `
      : `
    height: 190px;
    max-height: 190px;
    width: 100%;
    border-top-right-radius: 3px;
  `};

  ${(props) =>
    props.small
      ? `
    height: 100px;
    max-height: 100px;`
      : ``};
`

const CardContent = styled.section<{ compact: boolean }>`
  padding: ${(props) => (props.compact ? '10px' : '40px')};

  p {
    margin: 15px 0;
  }

  h2 {
    font-size: 1.2em;
  }
`

const CardMeta = styled.section`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 0.8em;
  opacity: 0.8;
  line-height: 1em;
`

const CardTitle = styled.h2`
  margin: 0;
  padding: 0;
`

export const Card: FunctionComponent<CardProps> = ({
  title,
  meta,
  path,
  featuredImage,
  content,
  halfImage = false,
  small = false,
  compact = false,
  style,
  children,
}) => (
  <StyledArticle style={style}>
    <StyledCard to={`/blog${path}`}>
      {featuredImage && (
        <FeaturedImage
          alt="Imagem principal"
          image={featuredImage}
          halfImage={halfImage}
          small={small}
        />
      )}
      <CardContent compact={compact}>
        {children}
        <header>
          {meta && (
            <CardMeta>
              {meta.tag && <>{meta.tag}</>}
              {meta.time && <time dateTime={meta.time}>{meta.timePretty}</time>}
            </CardMeta>
          )}
          {title && <CardTitle>{title}</CardTitle>}
        </header>
        {content && <p dangerouslySetInnerHTML={{ __html: content }} />}
      </CardContent>
    </StyledCard>
  </StyledArticle>
)
